import { store } from "./_ReduxHelper";
import logger from "./_Logger";
import * as langs from "../i18n";
import _ from "lodash";

const label = (id: string, from: "gloabl" | "i18n" = "i18n") => {
  const state = store.getState();
  const lang = state.session.lang ? state.session.lang : "en_US";
  switch (from) {
    case "i18n":
      if (langs[lang] && langs[lang][id]) {
        return langs[lang][id];
      } else {
        logger
          .getLogger("i18n-Util")
          .error("UNKNOWN LABEL ID: " + id + "@" + state.session.lang);
        return "*UNKNOWN LABEL*";
      }
    default:
      if (_.isEmpty(state.session.global)) {
        return "";
      }
      return state.session.global?.[id]?.D_VALUE;
  }
};

export default label;
